/**
 * Not every environment ships billing, so the subscriptions section can be switched off
 * per deployment. Unset means visible.
 *
 * Its own module rather than a const in `settings-sections`: sub-pages that point at the
 * section — a plan-gated permission offering an upgrade, say — need the same answer, and
 * `settings-sections` imports those sub-pages, so reading it from them would close a cycle.
 */
export const SUBSCRIPTIONS_HIDDEN = import.meta.env.VITE_HIDE_SUBSCRIPTIONS_TAB === 'true';
